/**
 * Created by Jonas Wålekvist on 2018-01-19.
 */
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {DungeonQuestHelper} from "../bigSymbols/DungeonQuestHelper";
import {DungeonQuestGameConfig, DungeonQuestGameMode, DungeonQuestSymbols} from "../DungeonQuestGameConfig";
import {DungeonQuestModeData} from "../server/DungeonQuestModeData";
import {DungeonQuestAttentionStateTimelineSprite} from "./stateSprites/DungeonQuestAttentionStateTimelineSprite";
import {DungeonQuestHighlightedOrDimmedStateSprite} from "./stateSprites/DungeonQuestHighlightedOrDimmedStateSprite";
import {DungeonQuestNoWinStateSprite} from "./stateSprites/DungeonQuestNoWinStateSprite";
import {DungeonQuestTransformStateTimelineSprite} from "./stateSprites/DungeonQuestTransformStateTimelineSprite";
import {DungeonQuestWinStateTimelineSprite} from "./stateSprites/DungeonQuestWinStateTimelineSprite";


export class DungeonQuestReelSymbolStateCreator extends ReelSymbolStateCreator {

    constructor() {
        super();
    }

    public createStateAnimation(symbol:StateReelSymbol, stateConfig:ISymbolStateConfig):TimelineSprite | null {
        let sprite:TimelineSprite | null = this.getDungeonQuestStateAnimation(symbol, stateConfig.keyword, stateConfig);
        return sprite;
    }

    private spriteCreator(symName:string, stateKey:string, textures:PIXI.Texture[]):TimelineSprite {
        if(stateKey == DungeonQuestGameConfig.instance.SYMBOL_STATES.spin.keyword &&
            DungeonQuestModeData.instance.highlightedReels &&
            DungeonQuestModeData.instance.transformSymbol != undefined) {

            //IF matching mid sym we leave as normal.
            if(DungeonQuestHelper.isMatchingLowMidPair(DungeonQuestModeData.instance.transformSymbol, symName) && DungeonQuestModeData.instance.mode == DungeonQuestGameMode.RANDOM_TRANSFORM) {
                return new TimelineSprite(textures);
            }
            return new DungeonQuestHighlightedOrDimmedStateSprite(DungeonQuestModeData.instance.transformSymbol == symName, textures);

        }

        if(stateKey == DungeonQuestGameConfig.instance.SYMBOL_STATES.reelStop.keyword &&
            DungeonQuestModeData.instance.highlightedReels &&
            DungeonQuestModeData.instance.transformSymbol != undefined) {

            //IF matching mid sym we leave as normal.
            if(DungeonQuestHelper.isMatchingLowMidPair(DungeonQuestModeData.instance.transformSymbol, symName) && DungeonQuestModeData.instance.mode == DungeonQuestGameMode.RANDOM_TRANSFORM) {
                return new TimelineSprite(textures);
            }


            return new DungeonQuestHighlightedOrDimmedStateSprite(DungeonQuestModeData.instance.transformSymbol == symName, textures);

        }

        if(stateKey == DungeonQuestGameConfig.instance.SYMBOL_STATES.highlighted.keyword) {
            return new DungeonQuestHighlightedOrDimmedStateSprite(true, textures);
        }
        if(stateKey == DungeonQuestGameConfig.instance.SYMBOL_STATES.dimmed.keyword) {
            return new DungeonQuestHighlightedOrDimmedStateSprite(false, textures);
        }

        if(stateKey == DungeonQuestGameConfig.instance.SYMBOL_STATES.noWin.keyword) {
            return new DungeonQuestNoWinStateSprite(textures);
        }

        if(stateKey == DungeonQuestGameConfig.instance.SYMBOL_STATES.win.keyword) {
            return new DungeonQuestWinStateTimelineSprite(1, symName, textures);
        }
        if(stateKey == DungeonQuestGameConfig.instance.SYMBOL_STATES.win2.keyword) {
            return new DungeonQuestWinStateTimelineSprite(2, symName, textures);
        }
        if(stateKey == DungeonQuestGameConfig.instance.SYMBOL_STATES.win3.keyword) {
            return new DungeonQuestWinStateTimelineSprite(3, symName, textures);
        }
        if(stateKey == DungeonQuestGameConfig.instance.SYMBOL_STATES.winToggle.keyword) {
            return new DungeonQuestWinStateTimelineSprite(0, symName, textures);
        }

        if(stateKey == DungeonQuestGameConfig.instance.SYMBOL_STATES.transform.keyword && symName != DungeonQuestSymbols.W && symName != DungeonQuestSymbols.W_STICKY) {
            return new DungeonQuestTransformStateTimelineSprite(textures);
        }

        if(stateKey == DungeonQuestGameConfig.instance.SYMBOL_STATES.attention.keyword) {
            return new DungeonQuestAttentionStateTimelineSprite(textures);
        }

        return new TimelineSprite(textures);
    }

    protected getDungeonQuestStateAnimation(symbol:StateReelSymbol, stateKey:string, stateConfig:ISymbolStateConfig,):TimelineSprite | null {
        if(stateConfig.symbols && stateConfig.symbols.indexOf(symbol.stackedSymName!.symName) === -1) {
            return null;
        }

        if(!stateConfig.texturesCreator) {
            stateConfig.texturesCreator = (symName:string, stateKey:string):PIXI.Texture[] => ReelSymbolStateCreator.defaultSymbolStateTexturesCreator(symName, stateKey);
        }

        const textures = stateConfig.texturesCreator(symbol.stackedSymName!.symName, stateKey);
        if(textures == null || textures.length === 0) {
            return null;
        }

        const sprite:TimelineSprite = this.spriteCreator(symbol.symName, stateKey, textures);
        if(symbol.stackedSymName!.isStacked) {
            sprite.anchor.set(0.5, MathHelper.floorToDecimals((symbol.stackedSymName!.index + 0.5) / symbol.stackedSymName!.totalNum, 4));
        } else {
            sprite.anchor.set(0.5, 0.5);
        }

        if(stateConfig.scaleGetter) {
            const scale:[number, number] = stateConfig.scaleGetter(symbol.stackedSymName!.symName, stateKey);
            sprite.scale.set(scale[0], scale[1]);
        }

        if(stateConfig.offsetGetter) {
            const offset:[number, number] = stateConfig.offsetGetter(symbol.stackedSymName!.symName, stateKey);
            sprite.position.set(offset[0], offset[1]);
        }
        return sprite;
    }


}